import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import MuiAlert from '@material-ui/lab/Alert';
import MuiAlertTitle from '@material-ui/lab/AlertTitle';
import { makeStyles } from '@material-ui/core/styles';
// Custom
import AppIcon from 'components/icons/AppIcon';

// Styles
const useStyles = (justifyContentCenter) => makeStyles(() => ({
  root: {
    justifyContent: justifyContentCenter ? 'center' : 'left',
    textAlign: justifyContentCenter ? 'center' : '',
  },
}));

const Alert = ({
  severity,
  icon,
  withInfoIcon,
  title,
  children,
  action,
  justifyContentCenter,
}) => {
  // Components props
  let alertProps = {
    severity,
    action,
    iconMapping: {
      success: <AppIcon id="notificationSuccess" />,
      info: <AppIcon id="notificationInfo" />,
      warning: <AppIcon id="notificationWarning" />,
      error: <AppIcon id="notificationError" />,
    },
    icon,
  };
  if (!withInfoIcon) {
    alertProps = {
      ...alertProps,
      icon: false,
    };
  }

  const classes = useStyles(justifyContentCenter)();

  return (
    <MuiAlert {...alertProps} classes={classes}>
      {title && <MuiAlertTitle>{title}</MuiAlertTitle>}
      {children}
    </MuiAlert>
  );
};

Alert.propTypes = {
  severity: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
  icon: PropTypes.node,
  withInfoIcon: PropTypes.bool,
  justifyContentCenter: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node.isRequired,
  action: PropTypes.node,
};

Alert.defaultProps = {
  severity: 'info',
  icon: null,
  withInfoIcon: false,
  justifyContentCenter: false,
  title: null,
  action: null,
};

export default React.memo(Alert);



// WEBPACK FOOTER //
// ./components/core/Alert.js